import { useCallback } from 'react'
import { useAppDispatch } from '../redux/store'
import { showSuccessMessage } from '../redux/reducers/snackbarReducer'
import { manualRequestsService } from '../services/myActionsService'
import { ScaMaintenanceRequest } from '../types/absence-sca'

/**
 * Custom hook for SCA-related operations
 */
export const useScaOperations = () => {
  const dispatch = useAppDispatch()

  const createSca = useCallback(
    async (data: ScaMaintenanceRequest) => {
      const result = await manualRequestsService.createSCA(data)
      dispatch(showSuccessMessage('SCA submitted'))
      return result
    },
    [dispatch]
  )

  const resubmitSca = useCallback(
    async (data: ScaMaintenanceRequest) => {
      const result = await manualRequestsService.resubmitSCA(data)
      dispatch(showSuccessMessage('SCA update submitted'))
      return result
    },
    [dispatch]
  )

  const fetchScaData = useCallback(
    async (absenceId: number) => {
      const result = await manualRequestsService.getSCA(absenceId)
      return result
    },
    [dispatch]
  )

  return {
    createSca,
    resubmitSca,
    fetchScaData,
  }
}